export default __webpack_public_path__ + "static/media/airstrapz-cbb-banner-1.849d3ae2.jpg";